<template>
  <el-dialog
    width="40%"
    :title="!dataForm.taskId ? '新增' : '任务详情'"
    :close-on-click-modal="false"
    :visible.sync="visible"
  >
    <el-form
      :model="dataForm"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="90px"
      class="form"
    >
      <el-form-item label="任务名称" prop="taskName">
        <el-input v-model="dataForm.taskName"  maxlength="100" disabled></el-input>
      </el-form-item>
      <el-form-item label="贡献值" prop="name">
        <el-input type="number" v-model="dataForm.energy"  min="0" disabled></el-input>
      </el-form-item>
      <el-form-item label="所属团队" prop="teamName">
        <el-input v-model="dataForm.teamName" disabled></el-input>
      </el-form-item>
      <el-form-item label="完成情况"></el-form-item>
      <el-form-item label label-width="20px" prop="name">
        <template>
          <el-table :data="dataForm.userTasks" style="width: 100%">
            <el-table-column prop="taskName" label="任务项" min-width="80"></el-table-column>
            <el-table-column prop="realName" label="姓名" min-width="80"></el-table-column>
            <el-table-column prop="jobNumber" label="工号" min-width="80"></el-table-column>
            <el-table-column prop="status" label="是否完成" min-width="80">
              <template slot-scope="scope">
                {{ scope.row.status == 'N'?'未处理':scope.row.status == 'Y'?'已完成': scope.row.status == 'I'?'进行中':'-'}}
              </template>
            </el-table-column>
            <el-table-column prop="energy" label="获得能量" min-width="80"></el-table-column>
          </el-table>
        </template>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">返回</el-button>
      <!-- <el-button type="primary" @click="dataFormSubmit()">确定</el-button> -->
    </span>
  </el-dialog>
</template>

<script>
import {taskInfoData, taskSaveData, taskUpdateData } from '../api'
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        taskId: '',
        taskName: "",
        userTasks: [],
        teamName: "",
        energy: "",
        createTime: "",
      },
    };
  },
  methods: {
    init(id) {
      this.dataForm.taskId = id || '';
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.taskId) {
         taskInfoData(this.dataForm.taskId).then(data => {
            if (data && data.code === 0) {
              this.dataForm.taskName = data.sysTask.taskName;
              this.dataForm.userTasks = data.sysTask.userTasks || [];
              this.dataForm.teamName = data.sysTask.teamName;
              this.dataForm.energy = data.sysTask.energy;
            } else {
              this.$message.error(data.msg);
            }
          });
        }else{
          this.dataForm = {}
        }
      });
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let psotData = {
              taskId: this.dataForm.taskId || undefined,
              taskName: this.dataForm.taskName,
              taskContent: this.dataForm.taskContent,
              sysSubtasks: this.dataForm.sysSubtasks,
              userTasks: this.dataForm.userTasks
          };
         taskSaveData(psotData).then(data => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .form{
    ::v-deep .el-input.is-disabled .el-input__inner{
      color: #000 !important;
    }
  }
</style>